import { createContext } from "react";

export default createContext({ region: "all", setRegion() {} });
